import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './add-to-basket-error.module.scss';

const AddToBasketError = ({ pdpUrl = '' }) => (
  <div className={styles.container}>
    <span data-testid="error-container">
      An unexpected error has occurred for this item. Please try again from the{' '}
      {pdpUrl ? (
        <a href={pdpUrl} className={styles.link}>
          product page
        </a>
      ) : (
        'product page'
      )}
      .
    </span>
  </div>
);

AddToBasketError.propTypes = {
  pdpUrl: PropTypes.string,
};

export default memo(AddToBasketError);
